import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import api from '../../../services/api';
import userService from '../../../services/UserService';
import { login, loginFailure, loginSuccess, logout, logoutFailure, logoutSuccess } from '.';

export default function* rootSaga() {
	yield takeLatest('persist/REHYDRATE', setToken);
	yield takeEvery(login, loginSaga);
	yield takeEvery(logout, logoutSaga);
}

function* loginSaga({ payload }) {
	const { email, password, navigate, next } = payload;
	try {
		const data = yield call(userService.login, email, password);
		api.defaults.headers.Authorization = `Bearer ${data.token}`;
		yield put(loginSuccess(data));
		navigate(next || '/clientes/listagem', { replace: true });
	} catch (error) {
		yield put(loginFailure(error));
	}
}
function* logoutSaga() {
	try {
		yield put(logoutSuccess());
	} catch (error) {
		yield put(logoutFailure(error));
	}
}

export function setToken({ payload }) {
	if (!payload) return;

	const { token } = payload.session;
	if (token) {
		api.defaults.headers.Authorization = `Bearer ${token}`;
	}
}
